import { type UseQueryResult, useQuery } from 'react-query';
import { RsuAwardService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetGrantRsuList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const grantRsuOptions = useQuery(
    ['getGrantRsuOptions'],
    async () => {
      return await handleRequest(RsuAwardService.getApiAwardApiAppRSUAwardUpcomingGrantList());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.grantName ?? '',
            value: item.grantId ?? '',
          };
        });
      },
    }
  );

  return grantRsuOptions;
};

export default useGetGrantRsuList;
